import React from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiAward,
  FiCheckSquare,
  FiGlobe,
  FiMessageCircle,
  FiPackage,
  FiShield,
  FiTrendingUp,
} from "react-icons/fi";

import PageHero from "../../components/PageHero/PageHero";
import Reveal from "../../components/Reveal/Reveal";
import SEO from "../../components/SEO/SEO";
import { buyerPromises, pageImages, whyChooseReasons } from "../../data/siteContent";

const reasonIcons = [
  FiTrendingUp,
  FiCheckSquare,
  FiAward,
  FiPackage,
  FiMessageCircle,
  FiGlobe,
  FiShield,
  FiArrowRight,
];

export default function WhyChooseUs() {
  return (
    <>
      <SEO
        title="Why Choose Us"
        description="See why buyers work with Thamizhi International Ventures for eco-focused sourcing, disciplined documentation, and premium export presentation."
        path="/why-choose-us"
        image={pageImages.whyChoose}
      />

      <PageHero
        eyebrow="Why choose us"
        title="Why Choose Us"
        description="International buyers need more than a supplier list. They need product clarity, packaging awareness, responsive updates, and a partner who understands how trust is built over repeat shipments."
        actions={[
          { label: "Explore services", to: "/services", variant: "primary" },
          { label: "View products", to: "/products", variant: "secondary" },
        ]}
        stats={[
          { label: "Buyer promise", value: "Clarity over guesswork" },
          { label: "Product direction", value: "Eco-conscious and market-led" },
          { label: "Working style", value: "Responsive, disciplined, long-term" },
        ]}
        media={
          <div className="overlap-visual overlap-visual--tall">
            <div className="overlap-visual__backdrop" aria-hidden="true" />
            <img src={pageImages.whyChoose} alt="Why choose Thamizhi International Ventures" />
          </div>
        }
      />

      <section className="section-band">
        <div className="section-shell">
          <Reveal>
            <div className="section-heading">
              <p className="section-kicker">Buyer advantages</p>
              <h2 className="section-title">Why the relationship works for international procurement teams</h2>
            </div>
          </Reveal>

          <div className="feature-grid">
            {whyChooseReasons.map((reason, index) => {
              const Icon = reasonIcons[index];

              return (
                <Reveal key={reason.title} className="feature-card" delay={index * 60}>
                  <div className="feature-card__icon">
                    <Icon aria-hidden="true" />
                  </div>
                  <h3>{reason.title}</h3>
                  <p>{reason.description}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section-band section-band--soft">
        <div className="section-shell">
          <Reveal>
            <div className="section-heading">
              <p className="section-kicker">What stays consistent</p>
              <h2 className="section-title">A few things we refuse to treat casually</h2>
            </div>
          </Reveal>

          <div className="promise-grid">
            {buyerPromises.map((promise, index) => (
              <Reveal key={promise} className="promise-card" delay={index * 70}>
                <span>{`0${index + 1}`}</span>
                <p>{promise}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section-band section-band--accent">
        <div className="section-shell cta-band">
          <Reveal>
            <p className="section-kicker">Ready to move</p>
            <h2 className="section-title">Let us shape the right product and shipment approach for your market</h2>
            <p className="section-copy">
              We are available for buyer conversations, category planning, and export support.
            </p>
          </Reveal>

          <Reveal className="cta-band__actions" delay={120}>
            <Link to="/contact" className="button button-primary">
              Contact us
              <FiArrowRight aria-hidden="true" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
